import { useState } from "react";
import { EntryMode, PutDistanceBand } from "../../../models/DecisionTable";

type DecisionTableEntryProps = {

    index: number,
    value: PutDistanceBand,

    /**
     * Callback method that gets executed when changes has been done.
     * @param entry
     * @param entryIndex
     * @returns
     */
    onConfirm: (entry: PutDistanceBand, entryIndex: number) => void,

    /**
     * Callback method that gets executed when entry should be deleted.
     * @param entryIndex
     * @returns
     */
    onDelete:  (entryIndex: number) => void
}

const DecisionTableEntry = ({ index, value, onConfirm, onDelete }: DecisionTableEntryProps) => {

    const [entry, setEntry] = useState<PutDistanceBand>(value);

    // #region Methods

    const renderButton = () => {

        switch (entry.mode) {
            case EntryMode.Display: return <><button className="btn btn-warning" onClick={e => setEntry(x => ({ ...x, mode: EntryMode.Edit }))}><i className="bi bi-pencil"></i></button> | <button className="btn btn-danger" onClick={e => onDelete(index)}><i className="bi bi-trash"></i></button></>
            case EntryMode.Edit:    return   <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg"></i></button>
            case EntryMode.Create:  return   <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg"></i></button>
        }
    }

    // #endregion

   const onSubmit = () => {

        let isValidInput: boolean = true; // Validate input!

       if ((entry.maxValue !== 0 && entry.minValue >= entry.maxValue)) { isValidInput = false; }
        if (entry.amount === 0) { isValidInput = false; }

        if (isValidInput) {

            entry.mode = EntryMode.Display;
            onConfirm(entry, index);
        }
    }

    return (
        <tr>
            <td>{entry.mode === EntryMode.Display ? (value.minValue) + " km": (<input type="number" onChange={e => setEntry(x => ({ ...x, minValue: Number(e.target.value) }))} value={entry.minValue} className="form-control" disabled></input>)}</td>
            <td>{entry.mode === EntryMode.Display ? (value.maxValue) + " km": (<input type="number" onChange={e => setEntry(x => ({ ...x, maxValue: Number(e.target.value) }))} value={entry.maxValue} className="form-control"></input>)}</td>
            <td>{entry.mode === EntryMode.Display ? (value.amount)  + " EUR": (<input type="number" onChange={e => setEntry(x => ({ ...x, amount:   Number(e.target.value) }))} value={entry.amount}   className="form-control"></input>)}</td>
            <td>
                {renderButton()}
            </td>
        </tr>
    )
}

export default DecisionTableEntry;